import { QueryDtoOf } from '@40seas/entities/common';
import { CurrencyConversion } from './currency-conversion.entity';

export class QueryCurrencyConversion extends QueryDtoOf(CurrencyConversion) {}
